// extracted by mini-css-extract-plugin
export var paginationContainer = "_99-0";